<template>
  <div>
    <div class="card modal-card-border infoWindowMap">
      <div class="card-content">
        <div :key="index" v-for="(reseau, index) in marker.reseaux"
             v-if="index === marker.indexReseauCourant" >
          <div>
            <div class="columns">
              <div class="column is-1">
                <a  @click="precedent()"
                    v-bind:class="{disabled: !peutAllerPrecedent() }">
                  <b-icon icon="chevron-left" class="arrow" size="is-large"></b-icon>
                </a>
              </div>
              <div class="column">
                <div class="information-title">
                  <h2 class="subtitle is-5">
                    {{marker.reseaux.length}} réseau(x)
                  </h2>
                  <h1 class="title is-6">{{reseau.libelle}}</h1>
                </div>
                <div class="detail-component">
                  <br>
                  <h1 class="subtitle is-6 information-title">Informations</h1>
                  <div class="columns">
                    <div class="column is-4">
                      <p class="information">Code réseau</p>
                      <span>{{reseau.code}}</span>
                    </div>
                    <div class="column is-4">
                      <p class="information">Nombre de faces</p>
                      <span>{{reseau.nbFaces}}</span>
                    </div>
                    <div class="column is-4">
                      <p class="information">Tarif brut</p>
                      <span>{{reseau.tarifBrut}}</span>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-4">
                      <p class="information">Ville</p>
                      <span>{{reseau.ville}}</span>
                    </div>
                    <div class="column is-4">
                      <p class="information" v-if="reseau.format">Format</p>
                      <span v-if="reseau.format">{{reseau.format}}</span>
                    </div>
                    <div class="column is-4">
                      <p class="information">Jour de départ</p>
                      <span>{{reseau.jourDepartLibelle}}</span>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-4">
                      <p class="information">Délai de conservation</p>
                      <span>{{reseau.dureeConservation}} </span>
                    </div>
                    <div class="column is-4">
                      <p class="information" v-if="reseau.confrere">Confrère</p>
                      <span v-if="reseau.confrere">{{reseau.confrere}}</span>
                    </div>
                    <div class="column is-4">
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-1">
                <a  @click="suivant()"
                    v-bind:class="{disabled: !peutAllerSuivant() }">
                  <b-icon icon="chevron-right" class="arrow" size="is-large"></b-icon>
                </a>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <button v-if="!dansPanier && !horsSecteur"
                        class="button is-primary"
                        @click="ajouterAuPanier(reseau)">
                  <b-icon icon="cart-plus"></b-icon><p>Ajouter au panier</p>
                </button>
                <button v-else-if="dansPanier"
                        class="button is-danger"
                        @click="ajouterAuPanier(reseau)">
                  <b-icon icon="cart-off"></b-icon><p>Retirer du panier</p>
                </button>
              </div>
              <div class="column">
              <button class="button is-primary"
                      @click="zoomReseau(marker)">
                <b-icon icon="magnify-plus"></b-icon><p>Zoom</p>
              </button>
              </div>
              <div class="column">
              <button class="button is-primary"
                      @click="openPopUpListeFaces(reseau)">
                <b-icon icon="view-list"></b-icon><p>Faces</p>
              </button>
              </div>
              <div class="column">
              <button class="button is-primary"
                      @click="ouvrirDiaporama(reseau)">
                <b-icon icon="image-multiple"></b-icon><p>Diaporama</p>
              </button>
              </div>
              <div class="column">
              <button class="button is-primary"
                      @click="exporterFicheProduit(reseau, marker.color)">
                <b-icon icon="file-pdf"></b-icon><p>Télécharger la fiche produit</p>
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="isComponentOuvrirListeFaces"
      has-modal-card
      class="modal modal-liste-faces"
      width="80vw">
      <Consultation
        :reseau="reseau"
        :disabled="disabled"
        :no-update="true"
        :horsSecteur="horsSecteur"
        :index-tabs="0"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import exporterFicheProduit from '@/services/reseauxTempo/exporterFicheProduit';
import getReseauAvecFaces from '@/services/reseauxTempo/getReseauAvecFaces';
import Consultation from '@/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo/consultation';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');
const Modal = createNamespacedHelpers('modal');
const Panier = createNamespacedHelpers('panier');
const ReseauxTempo = createNamespacedHelpers('reseauxTempo');

export default {
  name: 'info-window-map',
  props: ['marker', 'centre', 'nbFacesRestantes', 'dataProposition', 'horsSecteur'],
  components: {
    Consultation,
  },
  data() {
    return {
      infoAffiche: false,
      currentR: null,
      dansPanier: false,
      isComponentOuvrirListeFaces: false,
      reseau: null,
      disabled: true,
    };
  },
  watch: {
    marker(val) {
      for (let i = 0; i < this.marker.reseaux.length; i += 1) {
        const reseauPanier = this.reseauxTempoPanier.find((el) => {
          return el.num === this.marker.reseaux[i].num;
        });
        this.marker.reseaux[i].dansPanier = typeof reseauPanier === 'object';
      }
      this.currentR = val.indexReseauCourant;
      this.infoAffiche = false;
      if (!this.marker) {
        return;
      }
      if (this.marker) {
        this.infoAffiche = true;
      }
    },
    currentR(val) {
      this.dansPanier = this.marker.reseaux[val].dansPanier;
    },
  },
  computed: {
    ...VenteReseauxTempo.mapGetters({
      reseauxWithFilter: 'reseauxWithFilter',
      dateDeVisualisation: 'dateDeVisualisation',
    }),
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesReseauSelect: 'facesSelectDiapo',
    }),
    ...Panier.mapGetters({
      reseauxTempoPanier: 'reseauxTempoPanier',
    }),
    ...ReseauxTempo.mapGetters({
      reseaux: 'reseaux',
    }),
    facesReseauSelectDiapo: {
      get() {
        return this.getFacesReseauSelect;
      },
      set(value) {
        this.setFacesReseauSelect(value);
      },
    },
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
    allReseaux() {
      return this.reseauxWithFilter.concat(this.reseaux);
    },
  },
  methods: {
    ...VenteReseauxTempo.mapMutations({
      setReseauxSelected: types.SET_RESEAUX_SELECTED,
    }),
    ...VenteReseauxTempo.mapActions({
      actionsGestionPanier: 'gestionPanier',
    }),
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
      setFacesReseauSelect: typesModal.SET_FACES_SELECT_DIAPO,
    }),
    precedent() {
      if (this.peutAllerPrecedent()) {
        this.marker.indexReseauCourant = this.marker.indexReseauCourant - 1;
        this.currentR = this.marker.indexReseauCourant;
      }
    },
    suivant() {
      if (this.peutAllerSuivant()) {
        this.marker.indexReseauCourant = this.marker.indexReseauCourant + 1;
        this.currentR = this.marker.indexReseauCourant;
      }
    },
    peutAllerPrecedent() {
      return this.marker.indexReseauCourant !== 0;
    },
    peutAllerSuivant() {
      return this.marker.indexReseauCourant + 1 < this.marker.reseaux.length;
    },
    zoomReseau() {
      this.$emit('zoomReseau');
      this.$parent.close();
    },
    ouvrirDiaporama(reseau) {
      const newReseau = this.allReseaux.find((el) => {
        return el.num === reseau.num;
      });
      newReseau.listeFaces.forEach((el) => {
        el.libelleReseau = reseau.libelle;
      });
      this.facesReseauSelectDiapo = newReseau.listeFaces;
      this.isComponentDiaporama = true;
    },
    async ajouterAuPanier(data) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      if (data.dansPanier) {
        this.marker.reseaux[this.currentR].dansPanier = !data.dansPanier;
        this.dansPanier = this.marker.reseaux[this.currentR].dansPanier;
      }
      const semaine = moment(this.dateDeVisualisation).isoWeek();
      const annee = moment(this.dateDeVisualisation).isoWeekYear();
      await this.actionsGestionPanier({
        resNum: data.num,
        annee: annee,
        semaine: semaine,
        dataPropositions: this.dataProposition,
      });
      const reseauPanier = this.reseauxTempoPanier.find((el) => {
        return el.num === data.num;
      });
      this.setReseauxSelected({
        data: data.num,
        value: reseauPanier !== undefined && reseauPanier !== null,
      });
      loadingComponent.close();
    },
    async exporterFicheProduit(reseau, couleur) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await exporterFicheProduit({
          ...reseau,
          couleur,
        });
        loadingComponent.close();
      } catch (e) {
        gestionErreur(`Erreur lors de la generation du PDF du réseau id: ${reseau.num}`, e);
        loadingComponent.close();
      }
    },
    async openPopUpListeFaces(reseau) {
      const reseauComplet = this.allReseaux.find((el) => {
        return el.num === reseau.num;
      });
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        this.reseau = await getReseauAvecFaces(reseauComplet, this.dateDeVisualisation);
        this.isComponentOuvrirListeFaces = true;
      } catch (e) {
        gestionErreur(`Erreur lors de la récupération des faces du réseau tempo n°${reseau.num}`, e);
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>

<style scoped>
  .columns{
    margin:0px;
  }

  .mdi-chevron-right, .mdi-chevron-left{
    margin-left : 0px;
    margin-right : 0px;
    margin-top : 50px;
  }

  .bouton {
    margin-right: 10px;
  }

  .information {
    font-size:14px;
  }

  .information-title {
    margin-left:10px;
    margin-bottom:0;
  }

  .arrow {
    height: 30vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/recherche/cartographie/infoWindowMapReseaux.vue